import { ValueInput } from '@/components/form/ValueInput.tsx';
import { FilterInputProps } from '@/components/table/_fieldDefinitions/_base/FilterInputProps.ts';

export const MoneyValueFilterInput = ({ form, index }: FilterInputProps) => (
  <ValueInput
    size="toolbar"
    placeholder="Wpisz kwotę"
    register={form.register(`filters.${index}.value`)}
  />
);
